import { FC } from 'react';
import { renderMarkdown } from '../../posts-modal/lib/renderMarkdown';
import '../../posts-modal/ui/article-content.css';
import './news-preview.css';

interface Props {
	title?: string;
	tagLabel?: string;
	/** image_path обложки (как приходит с бэка, напр. media/posts/x.jpg). */
	coverImage?: string;
	date?: string;
	markdown: string;
	theme: 'light' | 'dark';
}

// Обложка/инлайн-картинки хранятся относительным путём — делаем корне-
// относительным, иначе src ломается на вложенных роутах.
const normalizeSrc = (path?: string): string | undefined => {
	if (!path) return undefined;
	if (/^(https?:)?\/\//.test(path) || path.startsWith('/') || path.startsWith('data:')) {
		return path;
	}
	return `/${path}`;
};

// Превью новости ровно так, как её увидит читатель (та же тема .article-content),
// включая стартовую обложку-hero. Тумблер light/dark — снаружи.
const NewsPreview: FC<Props> = ({ title, tagLabel, coverImage, date, markdown, theme }) => {
	const cover = normalizeSrc(coverImage);
	const hasBody = Boolean(markdown && markdown.trim());
	const titleText = title && title.trim() ? title : 'Заголовок новости';

	const meta = (
		<div className='news-preview__meta'>
			{tagLabel && <span className='news-preview__tag'>{tagLabel}</span>}
			{date && <span className='news-preview__date'>{date}</span>}
		</div>
	);

	return (
		<div className='news-preview' data-theme={theme}>
			{cover ? (
				<div className='news-preview__hero'>
					<img className='news-preview__hero-img' src={cover} alt='' />
					<div className='news-preview__hero-scrim' />
					<div className='news-preview__hero-content'>
						{meta}
						<h1 className='news-preview__title'>{titleText}</h1>
					</div>
				</div>
			) : (
				<div className='news-preview__header'>
					{meta}
					<h1 className='news-preview__title'>{titleText}</h1>
				</div>
			)}

			<div className='news-preview__body article-content' data-theme={theme}>
				{hasBody ? (
					<div dangerouslySetInnerHTML={{ __html: renderMarkdown(markdown) }} />
				) : (
					<div className='news-preview__empty'>Текст новости появится здесь…</div>
				)}
			</div>
		</div>
	);
};

export { NewsPreview };
